import React from "react";
import Modal from "react-modal";
import ReactMarkdown from "react-markdown";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../../../common/cardLayout/CardLayout";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "80vh",
    overflowY: "none",
  },
};
const ViewPinnedContent = ({
  modalIsOpen,
  setIsOpen,
  data,
  modalTitle = "Dual Login Detected",
}) => {
  // console.log("data", data);
  Modal.setAppElement("#root");
  function closeModal() {
    // alert("Modal is closed");
    setIsOpen(false);
  }
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="container-fluid">
            <h3 className="text-start">{data?.Title || modalTitle}</h3>
            <br />
            <div className="container-fluid">
              <>
              {(data?.media_type === "Videos" || data?.media_type === "ViewMedica") && (
                  <div
                    className="preview-section"
                    dangerouslySetInnerHTML={{
                      __html: data?.Embed,
                    }}
                  />
                )}

                {/* {data?.media_type === "TikToks" && (
                          <div
                            className="preview-section"
                            dangerouslySetInnerHTML={{
                              __html: selectedContent?.value?.TikTokEmbed,
                            }}
                          />
                        )} */}

                {data?.media_type === "Audio" && (
                  
                  <div
                  style={{
                    width: "100%",
                    height: "50lvh",
                    background: `url(${
                      data?.Thumbnail?.url ||
                      data?.classification?.Image?.formats?.thumbnail?.url ||
                      data?.Thumbnail?.formats?.thumbnail?.url ||
                      "https://placehold.co/600x400?text=."
                    }) no-repeat center/cover`,
                  }}
                >
                  <video
                    width="100%"
                    style={{
                      padding: "0px 50px",
                      height: "25vh",
                    }}
                    controls
                    name="media"
                  >
                    <source src={data?.Audio?.url} type="audio/mpeg" />
                  </video>
                </div>
                )}

                  {data?.media_type === "Article" && (
                  <>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <div
                        style={{
                          padding: "0px 10px",
                          height: "50lvh",
                          width: "50%",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "50lvh",
                            background: `url(${
                              data?.Picture?.url ||
                              data?.Picture?.formats?.thumbnail?.url ||
                              "https://placehold.co/600x400?text=."
                            }) no-repeat center/cover`,
                          }}
                        ></div>
                      </div>

                      <div
                        className="pb-4"
                        style={{
                          height: "50lvh",
                          width: "50%",
                          overflowY: "scroll",
                        }}
                      >
                        <ReactMarkdown children={data?.Body} />
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default ViewPinnedContent;
